import React, { FC, useRef, useState } from "react";
import { useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { TabPanel } from "react-tabs";
import { TabModel } from "../../../../models/tabModel";
import { getTabPanelByTab } from "../../../../selectors/tabListSelector";
import { ItemTypes } from "../../../../utils/itemTypes";
import RowElement from "../../RowElement";
import Modal from "react-modal";
import { SectionList } from "../../../../utils/constants";
import { startAddRow } from "../../../../actions/rowListAction";
import { getSession } from "../../../../selectors/appSelectors";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    color: "#fff",
    backgroundColor: "#222222",
  },
};

export interface TabPanelContentProps {
  index: number;
  tab: TabModel;
  isPreview?: boolean;
}

const TabPanelContent: FC<TabPanelContentProps> = ({
  index,
  tab,
  isPreview = false,
}) => {
  const dispatch = useDispatch();
  const ref = useRef<HTMLDivElement>(null);
  const rowList = useSelector(getTabPanelByTab(tab.id));
  const sessionState = useSelector(getSession);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [sectionCount, setSectionCount] = useState(0);

  const [{ isOver, isOverCurrent }, drop] = useDrop({
    accept: ItemTypes.LAYOUT,
    drop(item, monitor) {
      const didDrop = monitor.didDrop();
      const dropResult = monitor.getDropResult();
      if (didDrop) {
        return;
      }
      setIsOpen(true);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
  });

  const renderRowList = () => {
    return rowList.map((row, i) => {
      return <RowElement row={row} index={i} isPreview={isPreview} isTab={true} />;
    });
  };

  drop(ref);

  const className = `container tab-visual ${isOver ? "drop-hover-tab" : ""}`;

  return (
    <>
      {!isPreview && (
        <div ref={ref} key={`${index}-${tab.id}`} className={className}>
          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={() => {
              setSectionCount(1);
            }}
            onRequestClose={() => {
              setIsOpen(false);
            }}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <h6>Select Section</h6>
            <hr className="modal-footer pb-0 pt-0" />
            <select
              value={sectionCount}
              id="input-type"
              className="form-control theam-textbox"
              onChange={(e) => {
                setSectionCount(parseInt(e.target.value));
              }}
            >
              {SectionList.map((item, i) => {
                return (
                  <option key={i} value={item.value}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            <div className="modal-footer">
              <button
                className="btn btn-dark theam-btn theam-font"
                onClick={() => {
                  dispatch(
                    startAddRow(
                      {
                        type: "Tab",
                        formId: sessionState.selectedFormId,
                        tabId: tab.id,
                        sortKey: 0,
                        rowHighlight: true,
                        height: "",
                        width: "",
                        verticalAlign: "",
                        horizontalAlign: "",
                        cssStyles: [{}],
                        remark1: "",
                        remark2: "",
                        remark3: "",
                        remark4: "",
                        createdTime: "",
                        lastUpdatedTime: "",
                      },
                      sectionCount
                    )
                  );
                  setIsOpen(false);
                }}
              >
                <i className="fa fa-check" aria-hidden="true"></i>&nbsp;ADD
              </button>
              <button
                className="btn btn-dark theam-btn theam-font"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                <i className="fa fa-times" aria-hidden="true"></i>&nbsp;CLOSE
              </button>
            </div>
          </Modal>
          {renderRowList()}
        </div>
      )}
      {isPreview && renderRowList()}
    </>
  );
};

export default TabPanelContent;
